import { gql } from '@apollo/client';

export const GET_AUDIT_SESSION = gql`
  query GetAuditSession($communityId: ID!, $sessionId: ID!) {
    community(id: $communityId) {
      id
      name
      communityGroupId
      logoUrl
      optionalMetadata {
        description
        pgRating
        contentGenres
        contentStandardsUrl
        bigId
      }
      auditSession(sessionId: $sessionId) {
        id
        name
        description
        status
        createdBy
        createdAt
        completedAt
        lastModifiedBy
        lastModifiedAt
        itemsCount
        completedCount
        skippedCount
        pendingCount
        sampleParameters {
          communityId
          samplingParameters {
            confidenceLevel
            marginOfError
            populationProportion
            timeframe {
              start
              end
            }
          }
          filters {
            languages
            topics
            labels
            labelSeverities
            contentTypes
            violatesPolicy
          }
        }
        sampleStatistics {
          sampleSize
          confidenceLevel
          marginOfError
          populationSize
        }
        datasetComposition {
          byTopic {
            key
            count
            percentage
          }
          byLanguage {
            key
            count
            percentage
          }
          byLabel {
            key
            count
            percentage
          }
          bySeverity {
            key
            count
            percentage
          }
          totalItems
        }
      }
    }
  }
`;
